import React from "react";
import { CompassIcon, HeartIcon, LeafIcon, MessageCircleIcon, PaletteIcon, PenLineIcon, SparklesIcon, SproutIcon } from "lucide-react";
import { exerciseAreas, images, templateTools } from "../data/landing";
const icons = {
  palette: PaletteIcon,
  leaf: LeafIcon,
  message: MessageCircleIcon,
  heart: HeartIcon,
  compass: CompassIcon,
  sprout: SproutIcon,
  pen: PenLineIcon,
  sparkles: SparklesIcon
};
export function TechniquesSection() {
  return <section className="mx-auto max-w-6xl px-5 py-16 md:py-20" data-id="element-133" data-mp="3hbrxpyrsueqh">
      <div className="mx-auto max-w-3xl text-center" data-id="element-134" data-mp="3hdcrvna7bvnt">
        <h2 className="font-display text-2xl font-bold leading-snug text-ink md:text-3xl" data-id="element-135" data-mp="3oh4vgaee5w">
          Más de 50 formas diferentes de conectar contigo
        </h2>
        <p className="mt-4 text-lg text-muted" data-id="element-136" data-mp="3rc2aji9x9k54">
          Dentro del MegaPack encontrarás actividades diseñadas para ayudarte a detenerte, observar y expresar aquello
          que muchas veces queda dando vueltas en tu cabeza.
        </p>
      </div>

      <p className="mt-10 font-bold text-ink" data-id="element-137" data-mp="3b93z7j29msuw">Podrás encontrar ejercicios para:</p>
      <ul className="mt-4 grid gap-x-8 gap-y-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-138" data-mp="3g8gv0tb47a9m">
        {exerciseAreas.map(a => {
        const Icon = icons[a.icon];
        return <li key={a.text} className="flex items-start gap-3 text-ink" data-id="element-139" data-mp="3p9ofo8kpkcl8">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-lilac" data-id="element-140" data-mp="3p7u3bini5ssr">
                <Icon className="h-4 w-4 text-plum" aria-hidden="true" data-id="element-141" data-mp="2shukmvdn1dwg" />
              </span>
              <span className="pt-1.5 font-semibold leading-snug" data-id="element-142" data-mp="2xgo2t13vdt2y">{a.text}</span>
            </li>;
      })}
      </ul>
      <p className="mt-8 text-muted" data-id="element-143" data-mp="36au2h40w7k76">
        Cada técnica incluye instrucciones sencillas, un objetivo y una plantilla visual que puedes completar a tu
        manera.
      </p>

      <div className="mt-16 grid items-center gap-8 rounded-3xl bg-paper p-6 shadow-sm md:grid-cols-2 md:gap-12 md:p-10" data-id="element-144" data-mp="29rd5jtlqagtk">
        <img src={images.template} alt="Plantilla de árbol completada a mano con colores, garabatos y palabras" className="w-full rounded-2xl object-cover" loading="lazy" data-id="element-145" data-mp="3h55i1bl4mqsy" />
        <div data-id="element-146" data-mp="3qugn8n4w7bbk">
          <h2 className="font-display text-2xl font-bold text-ink md:text-3xl" data-id="element-147" data-mp="3qu70d8f59ka3">Tú completas cada ejercicio</h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-148" data-mp="3lx72hksg7nu2">
            No encontrarás páginas llenas de ilustraciones terminadas. Las plantillas están deliberadamente diseñadas
            con espacios abiertos para que seas tú quien las transforme utilizando:
          </p>
          <ul className="mt-5 flex flex-wrap gap-2" aria-label="Herramientas para completar las plantillas" data-id="element-149" data-mp="378ajisousqeo">
            {templateTools.map(t => <li key={t} className="rounded-full bg-lilac px-4 py-1.5 font-bold text-plum" data-id="element-150" data-mp="mha2ule9m6xi">
                {t}
              </li>)}
          </ul>
          <p className="mt-6 text-lg text-ink" data-id="element-151" data-mp="if5fu5ibo8ju">Porque no se trata de hacer algo “bonito”.</p>
          <p className="mt-1 font-display text-xl font-bold text-plum" data-id="element-152" data-mp="pxmqif1xptee">
            Se trata de crear algo que tenga sentido para ti.
          </p>
        </div>
      </div>
    </section>;
}